import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { FaFacebook, FaLinkedin } from 'react-icons/fa';
import reviewData from '../utils/reviewData';
import { Slide } from "react-awesome-reveal";
import hoverIcon from '../../images/review.png';
import 'swiper/css';
import 'swiper/css/pagination';

const Testimonial = () => {
    const [reviews] = useState(reviewData);
    const breakPoints = {
        320: {
            slidesPerView: 1,
            spaceBetween: 3,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
    }
    // what to render
    let content = null;
    if (reviews.length === 0) content = <h4>Loading</h4>
    if (reviews.length > 0) content =
        <>
            {
                reviews?.map(({ name, address, description, img, fb, linkdein, company, possition }, id) =>
                    <SwiperSlide key={name + id}>
                        <Slide direction='down'>
                            <div className="review">
                                <div className="reivew-hover-icon">
                                    <img src={hoverIcon} alt="" />
                                </div>
                                <img src={img} alt="" />
                                <h5 className="testimonialName">{name}</h5>

                                <div className="d-flex ">
                                    <div className="review-right">
                                        <div className="reseignation text-start">
                                            <p><strong>Company:</strong> {company}</p>
                                            <p><strong>Possiton:</strong> {possition}</p>
                                            <h6 className="testimonialAddress">{address}</h6>
                                        </div>

                                        <div className="review-desc-section d-flex justify-content-around">
                                            <div className="review-social d-flex flex-column text-start">
                                                <a href={linkdein} className="review-social-icon"><FaLinkedin className="icon" />Linkedin</a>
                                                <a href={fb} className="review-social-icon"><FaFacebook className="icon" />Facebook</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p className="review-desc"><i>{description}</i></p>
                            </div>
                        </Slide>
                    </SwiperSlide>
                )
            }
        </>
    return (
        <section id="testimonial">
            <div className="text-center mb-4">
                <h2 className="testimonial-title">REVIEWS</h2>
            </div>
            <div md={11} className="container mx-auto">
                <Swiper
                    modules={[Pagination, Autoplay]}
                    pagination={{ clickable: true }}
                    slidesPerView={3}
                    breakpoints={breakPoints}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    spaceBetween={8}
                >
                    {content}
                </Swiper>
            </div>
        </section>
    );
};

export default Testimonial;